module.exports = __webpack_public_path__ + "static/product1_4-c0990d4c750d4fe7b4cae8e7fea1838c.jpg";